"use client"
import React, { useState, useEffect } from "react";
import Image from "react-bootstrap/Image";
import useApi from "@/components/api/useApi";

import "@/components/shared/UralityImage.css";

const UralityAvatarImage = ({
  imageId,
  size,
  temporaryImage,
  addClass,
  name,
  type,
  outline = true,
  tooltip
}) => {
  const typeToColorMap = {
    BUSINESS: "#88dafb",
    AMBASSADOR: "#547863",
    POI: "#090B0B",
    COMMUNITY: "#397488",
    VOLUNTEER: "#547863"
  };

  const [url, setUrl] = useState(null);
  const [didLoad, setDidLoad] = useState(false);
  const [temporaryLogoImageUrl, setTemporaryLogoImageUrl] = useState(null);
  const api = useApi();

  useEffect(() => {
    if (imageId) {
      var theSize = "lg";
      if (size !== "sm" || size !== "md") {
        theSize = "xxl";
      }
      api.getSquareImage(imageId, theSize).then(url => {
        setUrl(url);
      });
    } else {
      setUrl(null);
    }
  }, [imageId, size]);

  const onLoad = () => setDidLoad(true);

  useEffect(() => {
    if (temporaryImage) {
      setTemporaryLogoImageUrl(`${temporaryImage}`);
    } else {
      setTemporaryLogoImageUrl(null);
    }
  }, [temporaryImage]);

  const nameAndTypeContent = (name, type) => {
    var content = name.substring(0, 1).toUpperCase();
    var bgcolor = typeToColorMap[type] ?? "#EEEEEE";
    return (
      <div className="name-and-type" style={{ backgroundColor: bgcolor }}>
        <span>{content}</span>
      </div>
    );
  };

  if (temporaryLogoImageUrl) {
    return (
      <Image
        id="temporary-avatar"
        className={`${addClass} urality-image-circle ${
          outline ? "outlined" : ""
        } ${size}`}
        src={temporaryLogoImageUrl}
        // style={sizeClass}
        roundedCircle
        title={tooltip}
      />
    );
  }
  if (url == null) {
    if (name && type) {
      return (
        <div
          className={`urality-image-circle ${
            outline ? "outlined" : ""
          } img-missing-rounded  ${size}`}
          title={tooltip}
        >
          {nameAndTypeContent(name, type)}
        </div>
      );
    } else {
      return (
        <div
          className={`urality-image-circle ${
            outline ? "outlined" : ""
          } img-missing-rounded  ${size}`}
          title={tooltip}
        />
      );
    }
  } else {
    return (
      <Image
        id={`urality-avatar-${imageId}`}
        src={url}
        alt={"..."}
        roundedCircle
        onLoad={() => onLoad()}
        style={didLoad ? {} : { visibility: "hidden" }}
        className={`${addClass} urality-image-circle ${
          outline ? "outlined" : ""
        } ${size}`}
        title={tooltip}
      />
    );
  }
};

export default UralityAvatarImage;
